function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.c{fill:#fff;opacity:0.64;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.4)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  fill: "none",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: "2px",
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(1.4 1)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  fill: "none",
  width: 32,
  height: 32,
  transform: "translate(0.4)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  fill: "#FFF",
  opacity: 0.64,
  d: "M22.18,25.28a26.282,26.282,0,0,1-.057-2.677A5.239,5.239,0,0,0,23.559,19.5c.365-.03.94-.386,1.109-1.792a1.312,1.312,0,0,0-.49-1.313c.594-1.786,1.827-7.311-2.281-7.882-.423-.743-1.506-1.118-2.913-1.118-5.629.1-6.308,4.251-5.074,9a1.315,1.315,0,0,0-.49,1.313c.169,1.406.744,1.762,1.109,1.792A5.228,5.228,0,0,0,16,22.6a26.287,26.287,0,0,1-.058,2.677c-.8,2.155-4.919,2.324-7.294,4.4A15.545,15.545,0,0,0,19.4,33.972c4.247,0,9.239-3.353,10.07-4.268C27.111,27.606,22.984,27.443,22.18,25.28Z",
  transform: "translate(-3.149 -2.431)"
}));

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "\n      {/* ", _ref2, " to be moved to styles.js*/}\n      ", _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1439386fa0a1625296c1209c2d9072a2.svg";
export { ForwardRef as ReactComponent };